import { useState } from "react";
import { useApp } from "../contexts";
import { agreePolicy } from "../services/app";
import environment from "../environment";
import moment from "moment";
import * as Sentry from "@sentry/react";

export default function useAffiliate() {
  const { user, reloadProfile, T } = useApp();
  const [isOpenModalPolicy, setIsOpenModalPolicy] = useState(false);
  const [isAgreeing, setIsAgreeing] = useState(false);
  const onAffiliate = (options = {}) => {
    try {
      const targetWindow = options?.targetWindow ?? null;

      if (Number(user?.is_agree_policy) === 0) {
        setIsOpenModalPolicy(true);
        if (targetWindow && !targetWindow.closed) {
          targetWindow.close();
        }
      } else {
        redirectToMlm(targetWindow);
      }
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          function: "onAffiliate",
        },
        extra: {
          userId: user?.id,
          mlmId: user?.mlm_id,
          isAgreePolicy: user?.is_agree_policy,
          hasTargetWindow: !!options?.targetWindow,
        },
      });
      throw error;
    }
  };

  const onConfirmPolicy = async () => {
    try {
      setIsAgreeing(true);
      await agreePolicy();
      setIsOpenModalPolicy(false);
      reloadProfile();
      redirectToMlm();
    } catch (error) {
      console.error("Failed to agree policy:", error);
      Notification.error(
        error?.response?.data?.message ??
          T("Something went wrong! Please try again later!")
      );
    } finally {
      setIsAgreeing(false);
    }
  };

  const redirectToMlm = (targetWindow) => {
    try {
      const urlMlmRegistration = getMlmRegistrationUrl();
      const targetUrl = user.mlm_id
        ? environment.MLM_LOGIN_URL
        : urlMlmRegistration;
      if (targetWindow && !targetWindow.closed) {
        targetWindow.location.href = targetUrl;
        if (typeof targetWindow.focus === "function") {
          targetWindow.focus();
        }
      } else {
        window.location.href = targetUrl;
      }
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          function: "redirectToMlm",
        },
        extra: {
          userId: user?.id,
          mlmId: user?.mlm_id,
          hasTargetWindow: !!targetWindow,
          targetWindowClosed: targetWindow ? targetWindow.closed : null,
        },
      });
      throw error;
    }
  };

  const getMlmRegistrationUrl = () => {
    try {
      const urlMlmRegistration = new URL(environment.MLM_REGISTRATION_URL);
      if (user.email) {
        urlMlmRegistration.searchParams.append("email", user.email);
      }
      if (user.dob) {
        urlMlmRegistration.searchParams.append("birth_date", moment(user.dob).format("YYYY-MM-DD"));
      }
      return urlMlmRegistration;
    } catch (error) {
      console.error(error);
      return environment.MLM_REGISTRATION_URL;
    }
  };
  return {
    onAffiliate,
    onConfirmPolicy,
    isOpenModalPolicy,
    setIsOpenModalPolicy,
    isAgreeing
  };
}
